export const ENVIROMENT = process.env.REACT_APP_ENV || ('development' as string)
export const WEEWILDAPI_URL = process.env.REACT_APP_WEEWILD_API_URL as string
export const IMG_URL = process.env.REACT_APP_WEEWILD_IMG_URL as string
